<template>
    <div>
        <back title="Register" route="/login-manual" v-if="showToolbar"></back>
        <register></register>
    </div>
</template>

<script>
    export default {
        props :{
            showToolbar : {
                type : Boolean,
                default : true
            }
        }
    }

</script>

<style lang="scss">
    @import "../scss/app.scss";
</style>
